module.exports = __webpack_public_path__ + "img/logo-black.253b42c8.png";